import Box from './Box';
import RefreshIcon from './RefreshIcon';

export default function RefreshButton({ onClick }) {
	return (
		<Box component="button" onClick={onClick} name="refresh" classes={['btn-with-icon', 'btn-link']}>
			Refresh
			<RefreshIcon />
		</Box>
	);
}
